module.exports = __webpack_public_path__ + "img/home_dynamic_title.0618791e.png";